import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { applyRuntimeConfig } from './environments/runtime-config';
import 'hammerjs';

/**
 * `AppModule` se carga DESPUÉS de aplicar la configuración de arranque (RECI-F00), y por eso
 * el import es dinámico: los metadatos de `@NgModule` se evalúan al importar el módulo
 * (`serviceWorker`, por ejemplo), así que con un import estático el árbol de la aplicación ya
 * habría leído el entorno compilado antes de que llegase el fichero. Cuesta un viaje de ida y
 * vuelta a un fichero minúsculo del mismo origen y sin caché; a cambio, no queda ninguna
 * clave leída antes de tiempo.
 */
applyRuntimeConfig(environment as unknown as Record<string, unknown>).then(async () => {
  if (environment.production) {
    enableProdMode();
  }

  const { AppModule } = await import('./app/app.module');

  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));

  // HRS-3045: el SDK de Sentry (~275 KB raw con replay) iba en el bundle inicial aunque el
  // DSN estaba a null. Ahora es un chunk propio que solo se descarga si el entorno define
  // `sentryDsn`. Sin replayIntegration (128 KB) mientras no se decida usarlo; si hace
  // falta, cargarlo con `Sentry.lazyLoadIntegration('replayIntegration')`.
  const sentryDsn = environment.sentryDsn;

  if (sentryDsn) {
    import('@sentry/angular')
      .then((Sentry) => {
        Sentry.init({
          dsn: sentryDsn,
          integrations: [Sentry.browserTracingIntegration()],
          tracesSampleRate: 1,
          enableLogs: true,
          environment: environment.production ? 'production' : 'development',
          release: 'ciceroneweb@1.0.0',
        });
      })
      .catch(() => {
        /* sin observabilidad: la app sigue funcionando */
      });
  }
});
